import truckImg from "../assets/images/loading-truck.webp";
import React, { useContext } from 'react';
import { GlobalContext } from '../globalContext';


export default function LoadingTruck() {

  const { store, updateStore, t } = useContext(GlobalContext);

  return (
    <div className="truck-loader-container">
      <img src={truckImg} alt={t.loadingPlaceholderTruck} className="truck-image" />
      <p className="loading-text">
       {t.loadingTruckFirstLabel}
       <br />
      {t.loadingTruckSecondLabel}
      </p>
    </div>
  );
}
